// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { configureStore, combineReducers, createAction } from "@reduxjs/toolkit";
import ballotStylesReducer from "./ballotStyles/ballotStylesSlice";
import castVotesReducer from "./castVotes/castVotesSlice";
import confirmationScreenDataReducer from "./castVotes/confirmationScreenDataSlice";
import ballotSelectionsReducer from "./ballotSelections/ballotSelectionsSlice";
import auditableBallotsReducer from "./auditableBallots/auditableBallotsSlice";
import electionsReducer from "./elections/electionsSlice";
import electionEventReducer from "./electionEvents/electionEventsSlice";
import supportMaterialReducer from "./supportMaterials/supportMaterialsSlice";
import documentsReducer from "./documents/documentsSlice";
import extraReducer from "./extra/extraSlice";
// note: use Immer, https://immerjs.github.io/immer/
export var clearVoterSession = createAction("session/clear");
var appReducer = combineReducers({
    elections: electionsReducer,
    castVotes: castVotesReducer,
    ballotStyles: ballotStylesReducer,
    ballotSelections: ballotSelectionsReducer,
    auditableBallots: auditableBallotsReducer,
    supportMaterials: supportMaterialReducer,
    electionEvent: electionEventReducer,
    extra: extraReducer,
    documents: documentsReducer,
    confirmationScreenData: confirmationScreenDataReducer,
});
export var store = configureStore({
    reducer: function (state, action) {
        return appReducer(clearVoterSession.match(action) ? undefined : state, action);
    },
});
